export default __webpack_public_path__ + "static/media/navigation-rail-labeled.887d4955.png";